import { getDay, getMonth, getFullYear } from 'utilities/dateHelper/dateHelper';
import { COUNTRY_DOCUMENT_TYPE_DNI, COUNTRY_DOCUMENT_TYPE_NIE } from 'constants/multiLanguage';

const GENDER_TYPE_M = 'M';
const GENDER_TYPE_F = 'F';

export const handleFormActions = (formActions, data) => {
    formActions.change('userProfile.documentType', getDocType(data.docType));
    formActions.change('userProfile.docNumber', data.docNumber);

    formActions.change('userProfile.name', data.name);
    formActions.change('userProfile.lastName', data.lastName1);

    formActions.change('userProfile.birthDay', getDay(data.birthdate));
    formActions.change('userProfile.birthMonth', getMonth(data.birthdate));
    formActions.change('userProfile.birthYear', getFullYear(data.birthdate));
    formActions.change('userProfile.birthDate', data.birthdate);
    formActions.change('userProfile.birthDayDisabled', true);

    formActions.change('userProfile.email', data.email);
    formActions.change('userProfile.emailConfirmation', data.email);

    formActions.change('userProfile.town', data.homeAddress.town);
    formActions.change('userProfile.country', data.homeAddress.country);
    formActions.change('userProfile.gender', getGender(data.gender));
    formActions.change('userProfile.cellPhone', data.cellphone);
    formActions.change('userProfile.cellPhoneConfirmation', data.cellphone);
    formActions.change('userProfile.cellphonePrefix', data.cellphonePrefix);
    formActions.change('userProfile.cellPhoneDisabled', true);
};

const docTypeMap = {
    DNI: COUNTRY_DOCUMENT_TYPE_DNI,
    NIE: COUNTRY_DOCUMENT_TYPE_NIE,
};

const getDocType = docType => {
    return docTypeMap[docType?.toUpperCase()] || '';
};

const getGender = genderType => {
    if (genderType?.toUpperCase() === GENDER_TYPE_M) {
        return 'male';
    }
    if (genderType?.toUpperCase() === GENDER_TYPE_F) {
        return 'female';
    }

    return '';
};
